<script>
    import DashboardSlideshow from "../components/dashboard_slideshow/DashboardSlideshow.svelte";
    import Menu from "../components/menu/Menu.svelte";
    import DefaultButton from "../components/DefaultButton.svelte";
    import MediaQuery from "svelte-media-query";
    import DashboardHeader from "../components/dashboard/DashboardHeader.svelte";
    import DashboardRow1 from "../components/dashboard/DashboardRow1.svelte";
    import DashboardRow2 from "../components/dashboard/DashboardRow2.svelte";
    import DashboardRow3 from "../components/dashboard/DashboardRow3.svelte";
    import DashboardRow4 from "../components/dashboard/DashboardRow4.svelte";
    import {_} from "svelte-i18n";
    import {menuRows} from "../content/static/menu";

    let openMenu = false;
    let flyAnimation;
    export let onSite = false;

    function showMenu() {
        openMenu = true;
    }

    function hideMenu() {
        openMenu = false;
    }

    function configMobile(matchesDesktop) {
        console.log("isDesktop: " + matchesDesktop.matches);
        if (matchesDesktop.matches) {
            flyAnimation = 300;
        } else {
            flyAnimation = 300;
        }
    }

    const matches = window.matchMedia("(min-width: 799px)");
    configMobile(matches);
    matches.addListener(configMobile);

    $: preloadImageUrls = [
        $menuRows[0][0].image,
        $menuRows[0][1].image,
        $menuRows[1][0].image,
        $menuRows[1][1].image,
    ];

    function slideForward() {
        console.log("slideForward");
        const element = document.getElementById("slider")
        const leftOffset = element.scrollLeft
        console.log(leftOffset)
        document.getElementById("slider").scroll({
            left: leftOffset + 720,
            behavior: "smooth",
        });
    }

    function slideBackward() {
        console.log("slideBackward");
        const element = document.getElementById("slider")
        const leftOffset = element.scrollLeft
        console.log(leftOffset)
        document.getElementById("slider").scroll({
            left: leftOffset < 720 ? 0 : leftOffset - 720,
            behavior: "smooth",
        });
    }
</script>

<svelte:head>
    {#each preloadImageUrls as image}
        <link rel="preload" as="image" href={image}/>
    {/each}
</svelte:head>

<main>
    <div class="background">
        <img
                style="width:100%; height:100%;"
                src="./images/dashboard/BG.png"
                alt="background"
        />
    </div>

    <!--Menu + Headerbar-->
    <MediaQuery query="(min-width: 799px)" let:matches>
        {#if openMenu}
            <Menu
                    {flyAnimation}
                    desktopAnimation={matches}
                    on:closeClicked={hideMenu}
            />
        {/if}
    </MediaQuery>

    <DashboardHeader
            on:click={showMenu}
            on:slideForward={slideForward}
            on:slideBackward={slideBackward}
            {onSite}
    />

    <!--Slider (Event/Audio)+ Headline-->
    <div class="dashBoardWrapper">
        <MediaQuery query="(min-width: 799px)" let:matches>
            {#if matches}
                <div id="slider" class="h1Slider event-slideshow">
                    <div class="greeting-section h1">
                        <div class="headline-custom ">
                            {$_("greeting")}
                        </div>
                    </div>

                    <div
                            class="divider-v"
                            style="height: 446px; margin-right: 8px;"
                    />
                    <div class="db-slide-width">
                        <DashboardSlideshow {onSite}/>
                    </div>
                </div>
            {:else}
                <div>
                    <div class="headline-l h1">{$_("greeting")}</div>
                    <div
                            class="divider-under-title"
                            style="margin-left:16px; margin-right:16px;margin-bottom: 24px;"
                    >
                        <div class="divider-h"/>
                    </div>
                    <div class="event-slideshow">
                        <DashboardSlideshow {onSite}/>
                    </div>
                </div>
            {/if}
        </MediaQuery>
        <div class="divider-top" style="margin-top: 24px">
            <div class="divider-h "/>
        </div>
        <div class="explore-area">
            <div class="first-area">
                <DashboardRow1 {onSite}/>
                <DashboardRow2/>
            </div>
            <div class="divider-v div-area"/>
            <div class="second-area">
                <DashboardRow3 {onSite}/>
                <DashboardRow4/>
            </div>
        </div>
        <!--Buttons-->
        <div class="button-area">
            <MediaQuery query="(max-width:799px)" let:matches>
                {#if matches}
                    <div class="divider-h"/>
                    <div
                            on:click={showMenu}
                            class="headline-xs pCursor"
                            style="display: flex; justify-content: center; margin-top: 32px; margin-bottom: 32px ;"
                    >
                        {$_("general")}
                    </div>
                {/if}
            </MediaQuery>
            <div class="divider-h div-button"/>
            <div>
                <DefaultButton
                        text={$_("tickets_title")}
                        on:click={() =>
                        window
                            .open(
                                $_("tickets_link"),
                                "_blank"
                            )
                            .focus()}
                />
            </div>
        </div>
    </div>

    <div
            style="display: flex; flex-direction: row; justify-content: center; padding: 0px 32px 16px 32px;"
    >
        <a href="/#/impressum">{$_("imprint")}</a>
        <div
                class="divider-v"
                style="height: 100%; min-width: 1px; margin: 0 16px;"
        />
        <a href={$_("data_privacy_link")}
        >{$_("data_privacy")}</a
        >
        <div
                class="divider-v"
                style="height: 100%; min-width: 1px; margin: 0 16px;"
        />
        <a href={$_("follow_us_link")}>{$_("follow_us")}</a>
    </div>
</main>

<style>
    .first-area {
        width: 100%;
    }

    .second-area {
        width: 100%;
    }

    .background {
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: -1;
        padding-top: 106px;
        -webkit-filter: blur(60px); /* Safari 6.0 - 9.0 */
        filter: blur(60px);
        width: 100vw;
        height: 1546px;
    }

    .dashBoardWrapper {
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
        width: 100vw;
        padding-top: 106px;
    }

    .h1 {
        margin: 0px;
        padding: 0px;
        margin-bottom: 12px;
        margin-left: 16px;
        margin-right: 16px;
        scroll-snap-align: start;
    }

    .event-slideshow {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        padding-top: 5px;
        scroll-snap-type: x mandatory;
        scroll-snap-stop: always;
        scroll-padding-left: 16px;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .event-slideshow::-webkit-scrollbar {
        display: none;
    }

    .button-area {
        padding-bottom: 69px;
        margin-left: 16px;
        margin-right: 16px;
    }

    .explore-area {
        display: flex;
        flex-direction: column;
        margin-left: 16px;
        margin-right: 16px;
    }

    .div-button {
        margin: 16px 0 16px 0;
    }

    .divider-top {
        margin-left: 16px;
        margin-right: 16px;
    }

    .greeting-section {
        display: flex;
        flex-direction: column;
    }

    .locale-selector {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: start;
        margin-top: 8px;
    }

    .locale-more {
        margin-left: 4px;
    }

    a {
        color: var(--black-100);
        text-decoration: none;
    }

    a:hover {
        color: var(--black-64);
    }

    .headline-custom {
        /* Headline/L */

        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 95%;
        /* identical to box height, or 46px */

        letter-spacing: -0.04em;
        text-transform: uppercase;

        color: var(--black-100);
    }

    @media only screen and (min-width: 800px) {
        .background {
            display: none;
        }

        .h1Slider {
            display: flex;
            flex-direction: row;
            margin-bottom: 48px;
        }

        .explore-area {
            flex-direction: row;
            justify-content: space-between;
            margin-left: 40px;
            margin-right: 40px;
            margin-top: 48px;
            margin-bottom: 48px;
        }

        .first-area {
            flex-basis: 58.9%;
        }

        .second-area {
            flex-basis: 41.1%;
        }

        .div-area {
            height: unset;
            align-self: stretch;
            margin-left: 26px;
            margin-right: 24px;
        }

        .button-area {
            margin-left: 40px;
            margin-right: 40px;
            padding-bottom: 52px;
        }

        .div-button {
            display: none;
        }

        .dashBoardWrapper {
            padding: 0px;
        }

        .divider-under-title {
            display: none;
        }

        .h1 {
            display: flex;
            flex-direction: column;
            flex-basis: 49%;
            font-style: normal;
            line-height: 95%;
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 40px;
            /* or 91px */

            letter-spacing: -0.04em;
            text-transform: uppercase;
        }

        .db-slide-width {
            display: flex;
            flex-basis: 51%;
            width: 49%;
        }

        .divider-top {
            margin-left: 40px;
            margin-right: 40px;
        }

        .headline-custom {
            line-height: 95%;
            font-size: 48px;
        }

        .event-slideshow {
            scroll-padding-left: 24px;
        }
    }

    @media only screen and (min-width: 1440px) {
        .headline-custom {
            line-height: 95%;
            font-size: 64px;
        }
    }
</style>
